import {Component, Input} from '@angular/core';
import {
  CalendarViewType,
  DEFAULT_PAGE_SIZE,
  EventItem,
  Lookups, MeasurementPrecisionTypes,
  Message,
  RegistrationStatus,
  UserDetail,
  UserEvent,
  UserStatistics
} from "@model";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MyTraceyTabs} from "../my-tracey.component";
import {MyTraceyCreateListComponent} from "../my-tracey-create-list/my-tracey-create-list.component";
import {AbstractComponent, UserEventGridItemType} from "@components";
import {
  EVENT_DETAILS, MY_TRACEY_EDIT,
  MY_TRACEY_FAVORITES, MY_TRACEY_ENTRY,
  MY_TRACEY_OVERVIEW,
  MY_TRACEY_RESULTS,
  MY_TRACEY_UPCOMING, PRIVATE_EVENT_CALENDAR_ROUTE
} from "../../../../../app-routing.module";

@Component({
  selector: 'app-my-tracey-overview',
  templateUrl: './my-tracey-overview.component.html',
  styleUrl: './my-tracey-overview.component.scss',
  standalone: false
})
export class MyTraceyOverviewComponent extends AbstractComponent{
  public readonly UPCOMING_EVENTS_COUNT: number = 3;

  @Input({required: true}) languages: Lookups[] = [];
  @Input() currentUserDetails: UserDetail | undefined;
  @Input() unreadMessages: Message[] | undefined;
  @Input() listOfEvents: EventItem[] = [];

  @Input() upcomingEvents: UserEvent[] = [];
  @Input() pastEvents: UserEvent[] = [];
  @Input() favoriteEvents: EventItem[] = [];
  @Input() recommendedEvents: EventItem[] = [];
  @Input() userStatistics: UserStatistics | undefined;

  latestEvent: EventItem | undefined;

  currentYear?: number;
  lastYear?: number;
  statsYear?: number | undefined;
  hasRealStats: boolean = false;

  constructor(private router: Router, public translocoService: TranslocoService, private route: ActivatedRoute, private modalService: NgbModal) {
    super();
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.lastYear = this.currentYear - 1;
    this.statsYear = this.userStatistics?.year ?? 0;
    this.hasRealStats = this.userStatistics?.year === this.currentYear && (this.userStatistics?.racesCount ?? 0) > 0;
  }


  goToEventDetailsPage(event: EventItem | undefined): void {
    if (event?.id) {
      ///todo fix routes!!!!
      this.router.navigate(
          [PRIVATE_EVENT_CALENDAR_ROUTE, EVENT_DETAILS],
          {
            queryParams: {
              eventId: event.id,
              isFinishedEvent: false
            }
          }
      );
    }
  }

  goToMyEntry(userEvent: UserEvent): void {
    const { race, event, competitor } = userEvent;
    if (!race?.id || !event?.id || !competitor?.id) {
      return;
    }
    this.router.navigate([MY_TRACEY_ENTRY], {
      queryParams: {
        competitorId: competitor.id }
    });
  }

  goToLatestEvent() {

  }

  goToEditProfile(){
    this.router.navigate([MY_TRACEY_EDIT]);
  }


  navigateToPage(page: MyTraceyTabs) {
    let url = MY_TRACEY_OVERVIEW;
    switch (page) {
      case MyTraceyTabs.UPCOMING:
        url = MY_TRACEY_UPCOMING;
        break;
      case MyTraceyTabs.FAVORITES:
        url = MY_TRACEY_FAVORITES;
        break;
      case MyTraceyTabs.RESULTS:
        url = MY_TRACEY_RESULTS;
        break;
    }
    this.router.navigate([url]);
  }


  loadMore() {

  }


  onOpenCreateList(){
    const modalRef = this.modalService.open(MyTraceyCreateListComponent, {
      centered: true,
      windowClass: 'my-tracey-create-list',
    });
  }


  scrollEvents(isScrollRight: boolean): void {
    const container = document.querySelector('.events-scroll-container') as HTMLElement;
    if (container) {
      const firstItem = container.querySelector('.event-item') as HTMLElement;
      if (firstItem) {
        const itemWidth = firstItem.offsetWidth;
        const scrollAmount = isScrollRight ? itemWidth : -itemWidth;
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
  }

  goToEventCalendar() {
    this.router.navigate([PRIVATE_EVENT_CALENDAR_ROUTE]);
  }


  protected readonly MyTraceyTabs = MyTraceyTabs;
  protected readonly UserEventGridItemType = UserEventGridItemType;
  protected readonly RegistrationStatus = RegistrationStatus;
  protected readonly CalendarViewType = CalendarViewType;
  protected readonly DEFAULT_PAGE_SIZE = DEFAULT_PAGE_SIZE;
  protected readonly MeasurementPrecisionTypes = MeasurementPrecisionTypes;
}
